import { render, staticRenderFns } from "./guahaofangshi.vue?vue&type=template&id=10655a6f&scoped=true"
import script from "./guahaofangshi.vue?vue&type=script&lang=js"
export * from "./guahaofangshi.vue?vue&type=script&lang=js"
import style0 from "./guahaofangshi.vue?vue&type=style&index=0&id=10655a6f&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10655a6f",
  null
  
)

export default component.exports